/* @flow */
import * as React from 'react';
import theme from './PersonnelIdDisplay.scss';
import { translate } from 'react-i18next';

const PersonnelIdDisplay = props => {
    const { t, clientId, personnelId } = props;
    const userName = `${clientId}/${personnelId}`;
    return (
        <div className={theme.userNameSection}>
            <div className={theme.userNameTitle}>{t('userName')}</div>
            <div className={theme.userNameValue}>{userName}</div>
        </div>
    );
};
const EnhancedPersonnelIdDisplay = translate('settings')(PersonnelIdDisplay);
export { EnhancedPersonnelIdDisplay as PersonnelIdDisplay };
